import React, { useContext } from 'react';
import { Form, Typography } from 'antd';
import { getTranslatedString } from 'helpers/i18n';
import { ApplicationUIContext } from '@yuhuinc/ui-library';
import { SpaceFullWidth } from '../../common/Styles';

const { Title } = Typography;

const translate = (key) =>
  getTranslatedString(`landlordPortal.applicationManagement.leaseOverview.${key}`);

const AdditionalInformation = () => {
  const { isMobile } = useContext(ApplicationUIContext);

  return (
    <>
      <Title level={isMobile ? 4 : 5}>{translate('leaseDetails.additionalInformation')}</Title>
    </>
  );
};

export default AdditionalInformation;
